import { authRequest } from './authRequest';

export const authFetch = (url, config) => {
  
  return authRequest(url, config)
  .then(() => {
      return Promise.resolve(true);      
  }).catch(() => {        
      return Promise.resolve(false);
    }
  );
}